export default {
  'Choose File': '选择文件',
  'Please paste a URL': '输入一个视频URL链接',
  'Loading': '加载中',
  'Analyzing': '获取中',
  'Try a sample': '试一试示例',
  'Sorry, error occurs when analyzing the URL.': '抱歉，URL解析出错了。',
  'Upload a photo': '上传一张图片',
  "Drag and drop files to the upload box.": '拖拽文件到上传框。',
  'Please select the proper position with portrait.': '请裁剪出合适的人脸部分。',
  'downloading': '下载中',
}